import Stack from "@mui/material/Stack";
import { FC } from "react";

export interface PortalLayoutProps {
	slots: {
		BannerHeadline?: FC;
		RowView?: FC;
		Filters?: FC;
		MediumView?: FC;
		LargeView?: FC;
	};
}

const Empty = () => <></>;

export const PortalLayout: FC<PortalLayoutProps> = ({
	slots: {
		BannerHeadline = Empty,
		RowView = Empty,
		Filters = Empty,
		MediumView = Empty,
		LargeView = Empty,
	} = {},
}) => {
	return (
		<Stack spacing={4}>
			<BannerHeadline />
			<Filters />
			<RowView />
			<MediumView />
			<LargeView />
		</Stack>
	);
};
